module.exports = __webpack_public_path__ + "static/media/block-icon.ad55804f.svg";